import { render, staticRenderFns } from "./SharedUserName.vue?vue&type=template&id=4c75bf6e&scoped=true&"
import script from "./SharedUserName.vue?vue&type=script&lang=js&"
export * from "./SharedUserName.vue?vue&type=script&lang=js&"
import style0 from "./SharedUserName.vue?vue&type=style&index=0&id=4c75bf6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c75bf6e",
  null
  
)

export default component.exports